import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchGlobalServiceProfileQuery } from '@module/queries/global-service/globalServiceQueryHooks';
function useGlobalServiceViewModel() {
  const $ = _c(11);
  const {
    userInfo
  } = useGetLoginInfoQuery();
  const canAccessGlobalService = userInfo?.globalBJYN === "Y";
  const nickJa = userInfo?.nickJa || "";
  const userIdx = userInfo?.idx || 0;
  let t0;
  if ($[0] !== userIdx) {
    t0 = {
      userIdx
    };
    $[0] = userIdx;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!userIdx;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      enabled: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data
  } = useFetchGlobalServiceProfileQuery(t0, t2);
  const jaProfileData = data?.ja;
  const koProfileData = data?.ko;
  const {
    stationTitle: _stationTitle,
    ...globalProfileDataExceptStationTitle
  } = koProfileData || {};
  const isShowGlobalNoticeBanner = Object.values(globalProfileDataExceptStationTitle).every(_temp);
  const isAllEmptyGlobalProfileData = Object.values(koProfileData || {}).every(_temp2);
  let t3;
  if ($[4] !== canAccessGlobalService || $[5] !== isAllEmptyGlobalProfileData || $[6] !== isShowGlobalNoticeBanner || $[7] !== jaProfileData || $[8] !== koProfileData || $[9] !== nickJa) {
    t3 = {
      jaProfileData,
      koProfileData,
      isAllEmptyGlobalProfileData,
      isShowGlobalNoticeBanner,
      canAccessGlobalService,
      nickJa
    };
    $[4] = canAccessGlobalService;
    $[5] = isAllEmptyGlobalProfileData;
    $[6] = isShowGlobalNoticeBanner;
    $[7] = jaProfileData;
    $[8] = koProfileData;
    $[9] = nickJa;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp2(value_0) {
  return !value_0;
}
function _temp(value) {
  return !value;
}
export default useGlobalServiceViewModel;